document.addEventListener('DOMContentLoaded', function () {
  var zoomBox = document.getElementById('ProductImageZoom');
  var mainImg = document.getElementById('ProductMainImage');

  if (!zoomBox || !mainImg) return;

  var desktopZoom = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (!desktopZoom) return;

  var zoomLoaded = false;
  var raf = null;
  var posX = 50;
  var posY = 50;

  function getZoomSrc() {
    return zoomBox.getAttribute('data-zoom-image') || mainImg.getAttribute('src');
  }

  function loadZoomImage() {
    if (zoomLoaded) return;
    var zoomSrc = getZoomSrc();
    if (!zoomSrc) return;
    zoomBox.style.backgroundImage = 'url("' + zoomSrc + '")';
    zoomLoaded = true;
  }

  function refreshZoomImage() {
    var zoomSrc = getZoomSrc();
    if (!zoomSrc) return;
    zoomBox.style.backgroundImage = 'url("' + zoomSrc + '")';
    zoomLoaded = true;
  }

  function updatePosition() {
    zoomBox.style.backgroundPosition = posX + '% ' + posY + '%';
    raf = null;
  }

  function onMouseMove(e) {
    var rect = zoomBox.getBoundingClientRect();
    posX = ((e.clientX - rect.left) / rect.width) * 100;
    posY = ((e.clientY - rect.top) / rect.height) * 100;

    if (!raf) {
      raf = window.requestAnimationFrame(updatePosition);
    }
  }

  zoomBox.addEventListener('mouseenter', function () {
    loadZoomImage();
    zoomBox.classList.add('is-zoomed');
    zoomBox.style.backgroundSize = '200%';
  });

  zoomBox.addEventListener('mousemove', onMouseMove);

  zoomBox.addEventListener('mouseleave', function () {
    zoomBox.classList.remove('is-zoomed');
    zoomBox.style.backgroundPosition = 'center';
    zoomBox.style.backgroundSize = '100%';
  });

  if ('MutationObserver' in window) {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'src') {
          zoomLoaded = false;

          var newSrc = mainImg.getAttribute('src');
          if (!newSrc) return;

          var zoomSrc = newSrc
            .replace(/_[0-9]+x(\.[a-zA-Z]+)(\?.*)?$/, '_1800x1800$1$2')
            .replace(/_[0-9]+x[0-9]+(\.[a-zA-Z]+)(\?.*)?$/, '_1800x1800$1$2');

          zoomBox.setAttribute('data-zoom-image', zoomSrc);
          refreshZoomImage();
          zoomBox.classList.remove('is-zoomed');
          zoomBox.style.backgroundPosition = 'center';
          zoomBox.style.backgroundSize = '100%';
        }
      });
    });

    observer.observe(mainImg, {
      attributes: true,
      attributeFilter: ['src']
    });
  }
});